import { ArticleNonParagraphProps } from "@pages/Article/components/ArticleParagraphElements/utils/types";
import { cn } from "@util/helpers";
import parse, { DOMNode, domToReact, Element } from "html-react-parser";

/**
 * Renders an inline podcast element in an article.
 * This component processes the body string to extract the iframe for the podcast
 * and applies appropriate styles and classes.
 */
const InlinePodcast = ({
  bodyString,
  className,
  paragraphWidth,
}: ArticleNonParagraphProps): React.ReactElement => {
  const transformPodcast = (
    node: DOMNode
  ): string | boolean | void | object | Element | null => {
    if (node.type === "tag" && node.name === "iframe") {
      const el = node;
      const children = el.children as DOMNode[];
      const removedAttributes = ["class"];
      const attributes = Object.fromEntries(
        Object.entries(el.attribs).filter(
          ([key]) => !removedAttributes.includes(key)
        )
      );
      const size = attributes["data-size"];

      return (
        <iframe
          {...attributes}
          className={cn(
            "mx-auto mb-4 max-w-full md:mb-6",
            { "aspect-square h-auto": size === "square" },
            className,
            paragraphWidth
          )}
          data-testid="article-inline-podcast-component"
          title={attributes.title || "Podcast"}
        >
          {domToReact(children)}
        </iframe>
      );
    }
  };

  return <>{parse(bodyString, { replace: transformPodcast })}</>;
};

export default InlinePodcast;
